import { useState } from 'react';
import { Text, TextProps } from 'basic-ui-lib';
import styled from 'styled-components';
import colors from 'basic-ui-lib/constants/colors';
import { ColorPath } from 'basic-ui-lib/constants/colors';

const argTypes: TextProps[] = [
  { title_h1: true, children: 'Title/H1' },

  { title_h2: true, children: 'Title/H1' },

  { title_h3: true, children: 'Title/H1' },

  { title_h4: true, children: 'Title/H1' },

  { title_h5: true, children: 'Title/H1' },

  { title_h6: true, children: 'Title/H2' },

  { title_h7: true, children: 'Title/H2' },

  { title_h8: true, children: 'Title/H3' },

  { title_h9: true, children: 'Title/H3' },

  { content_1: true, children: 'Content/Content 1' },

  { content_2: true, children: 'Content/Content 2' },

  { content_3: true, children: 'Content/Content 3' },

  { body_1: true, children: 'Body/Body 1' },

  { caption_1: true, children: 'Caption/Caption 1' },

  { caption_2: true, children: 'Caption/Caption 2' },

  { caption_3: true, children: 'Caption/Caption 3' },

  { caption_4: true, children: 'Caption/Caption 4' },
];
export const TextStoryboard = () => {
  const [fontWeight, setFontWeight] = useState('regular');
  const [color, setColor] = useState<ColorPath>('neutral.text.6');
  const [link, setLink] = useState<boolean>(false);
  const [caplock, setCaplock] = useState<boolean>(false);
  const [align, setAlign] = useState<'center' | 'left' | 'right'>('center');
  const [lineClamp, setLineClamp] = useState<number>(1);

  const buttonColorTypes = [
    { key: 'neutral.text.1', value: 'Neutral Text 1', bgColor: colors.neutral.text[1], textColor: '' },
    { key: 'neutral.text.2', value: 'Neutral Text 2', bgColor: colors.neutral.text[2], textColor: '' },
    { key: 'neutral.text.3', value: 'Neutral Text 3', bgColor: colors.neutral.text[3], textColor: 'white' },
    { key: 'neutral.text.4', value: 'Neutral Text 4', bgColor: colors.neutral.text[4], textColor: 'white' },
    { key: 'neutral.text.5', value: 'Neutral Text 5', bgColor: colors.neutral.text[5], textColor: 'white' },
    { key: 'neutral.text.6', value: 'Neutral Text 6', bgColor: colors.neutral.text[6], textColor: 'white' },
    { key: 'primary.1', value: 'Primary 1', bgColor: colors.primary[1], textColor: 'black' },
    { key: 'primary.2', value: 'Primary 2', bgColor: colors.primary[2], textColor: 'black' },
    { key: 'primary.3', value: 'Primary 3', bgColor: colors.primary[3], textColor: 'white' },
    { key: 'primary.4', value: 'Primary 4', bgColor: colors.primary[4], textColor: 'white' },
    { key: 'primary.5', value: 'Primary 5', bgColor: colors.primary[5], textColor: 'white' },
    { key: 'secondary.1', value: 'Secondary 1', bgColor: colors.secondary[1], textColor: 'black' },
    { key: 'secondary.2', value: 'Secondary 2', bgColor: colors.secondary[2], textColor: 'black' },
    { key: 'secondary.3', value: 'Secondary 3', bgColor: colors.secondary[3], textColor: 'white' },
    { key: 'secondary.4', value: 'Secondary 4', bgColor: colors.secondary[4], textColor: 'white' },
    { key: 'secondary.5', value: 'Secondary 5', bgColor: colors.secondary[5], textColor: 'white' },
    { key: 'purple.1', value: 'Purple 1', bgColor: colors.purple[1], textColor: 'black' },
    { key: 'purple.2', value: 'Purple 2', bgColor: colors.purple[2], textColor: 'black' },
    { key: 'purple.3', value: 'Purple 3', bgColor: colors.purple[3], textColor: 'white' },
    { key: 'purple.4', value: 'Purple 4', bgColor: colors.purple[4], textColor: 'white' },
    { key: 'other.1', value: 'Other 1', bgColor: colors.other[1], textColor: 'black' },
    { key: 'other.2', value: 'Other 2', bgColor: colors.other[2], textColor: 'black' },
    { key: 'other.3', value: 'Other 3', bgColor: colors.other[3], textColor: 'white' },
  ];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div>
        <Button onClick={() => setFontWeight('regular')}>Regular</Button>
        <Button onClick={() => setFontWeight('medium')}>Medium</Button>
        <Button onClick={() => setFontWeight('semibold')}>Semibold</Button>
        <Button onClick={() => setFontWeight('bold')}>Bold</Button>
      </div>
      <div>
        <Button onClick={() => setAlign('left')}>Left</Button>
        <Button onClick={() => setAlign('center')}>Center</Button>
        <Button onClick={() => setAlign('right')}>Right</Button>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
        {buttonColorTypes.map((item) => (
          <Button
            key={item.key}
            onClick={() => setColor(item.key as ColorPath)}
            style={{ backgroundColor: item.bgColor, color: item.textColor }}
          >
            {item.value}
          </Button>
        ))}
      </div>
      <div>
        {/* button link */}
        <Button onClick={() => setLink(!link)}>Link</Button>
        <Button onClick={() => setCaplock(!caplock)}>Caplock</Button>
      </div>
      <div>
        Input line clamp:{' '}
        <input type='number' value={lineClamp} onChange={(e) => setLineClamp(Number(e.target.value))} />
      </div>
      {argTypes.map((arg, index) => (
        <Text
          key={index}
          {...arg}
          regular={fontWeight === 'regular'}
          medium={fontWeight === 'medium'}
          semibold={fontWeight === 'semibold'}
          bold={fontWeight === 'bold'}
          color={color}
          link={link}
          caplock={caplock}
          center={align === 'center'}
          left={align === 'left'}
          right={align === 'right'}
          // also add style and className, action onClick
        />
      ))}
      <Text title_h1>ELLIPSIS</Text>
      <div style={{ width: 500, display: 'flex', gap: 10, margin: 'auto' }}>
        <Text ellipsis lineClamp={lineClamp}>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem praesentium illo aperiam facere sed
          architecto, in magni rem tempore adipisci nulla eum voluptas id. Nisi omnis architecto at iusto illum?
        </Text>
        <Text ellipsis lineClamp={lineClamp}>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem praesentium illo aperiam facere sed
          architecto, in magni rem tempore adipisci nulla eum voluptas id. Nisi omnis architecto at iusto illum?
        </Text>
        <Text ellipsis lineClamp={lineClamp}>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem praesentium illo aperiam facere sed
          architecto, in magni rem tempore adipisci nulla eum voluptas id. Nisi omnis architecto at iusto illum?
        </Text>
      </div>
    </div>
  );
};

const Button = styled.button`
  padding: 10px 20px;
  border: 1px solid #000;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 10px;
`;
